import { Reducer } from "redux";
import { Action, ActionType } from "../../actions";
import { EditorData } from "../../state/Supplier/EditorData";

const updateSupplierEditorData: Reducer<EditorData> = (state: EditorData = new EditorData(), action: Action<ActionType, EditorData>) => {
  switch (action.type) {
    case ActionType.SUPPLIER_EDITOR_DATA_RESET:
      return new EditorData();
    case ActionType.SUPPLIER_EDITOR_DATA_FETCHED:
      return { ...state, supplierEditorData:  { ...action.data}  };
    case ActionType.SUPPLIER_EDITOR_DATA_COPIED:
      return { ...state, supplierEditorData: { ...action.data} };
    case ActionType.SUPPLIER_EDITOR_DATA_UPDATED:
      return { ...state, supplierEditorData: { ...state.supplierEditorData, ...action.data } };
    case ActionType.SUPPLIER_EDITOR_DATA_SAVED:
      return { ...state, readyToSave: false };
    case ActionType.SUPPLIER_EDITOR_DATA_VALIDATED:
      return { ...state, validation: {...action.data }};
    case ActionType.SUPPLIER_EDITOR_SET_BOUND_ITEM:
      return {...state, supplierEditorData: {...state.supplierEditorData, ...action.data}}
    default:
      return state;
  }
  
};

export default updateSupplierEditorData;
